<template>
  <div v-loading="loading">
    <!--  -->
    <div style="text-align: center; margin-top: 16px">
      <GradientBtn v-if="isDev" @click="setTestValue">
        一鍵賦值（Dev）
      </GradientBtn>
    </div>
    <!--  -->
    <el-form
      v-if="isFollowing"
      ref="form"
      :model="form"
      label-position="top"
      hide-required-asterisk
    >
      <!-- 車輛信息 -->
      <form-box :title="$t('hzmbG.title.vehicle')">
        <div class="form_type1_box">
          <el-row :gutter="86">
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbH.label.registrationNo')">
                <el-input
                  v-model="form.vehicle.registrationNo"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.mainlandInsuranceNo')">
                <el-input
                  v-model="form.vehicle.mainlandInsuranceNo"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.mainlandInsuranceStartDate')"
              >
                <el-date-picker
                  v-model="form.vehicle.mainlandInsuranceStartDate"
                  :picker-options="{
                    disabledDate: (event) =>
                      setDateOff(event, 'mainlandInsuranceStartDate'),
                  }"
                  type="date"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.mainlandInsuranceEndDate')">
                <el-date-picker
                  v-model="form.vehicle.mainlandInsuranceEndDate"
                  :picker-options="{
                    disabledDate: (event) =>
                      setDateOff(event, 'mainlandInsuranceEndDate'),
                  }"
                  type="date"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </form-box>
      <!-- 車輛信息 end -->
    </el-form>
    <!-- form -->
    <el-form
      v-else
      ref="form"
      :model="form"
      label-position="top"
      hide-required-asterisk
    >
      <!-- 車輛信息 -->
      <form-box :title="$t('hzmbG.title.vehicle')">
        <div class="form_type1_box">
          <el-row :gutter="86">
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbH.label.registrationNo')">
                <el-input
                  v-model="form.vehicle.registrationNo"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.mainlandInsuranceNo')">
                <el-input
                  v-model="form.vehicle.mainlandInsuranceNo"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbG.label.mainlandInsuranceStartDate')"
              >
                <el-date-picker
                  v-model="form.vehicle.mainlandInsuranceStartDate"
                  :picker-options="{
                    disabledDate: (event) =>
                      setDateOff(event, 'mainlandInsuranceStartDate'),
                  }"
                  type="date"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbG.label.mainlandInsuranceEndDate')">
                <el-date-picker
                  v-model="form.vehicle.mainlandInsuranceEndDate"
                  :picker-options="{
                    disabledDate: (event) =>
                      setDateOff(event, 'mainlandInsuranceEndDate'),
                  }"
                  type="date"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col> -->
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbH.label.mainlandRegistrationNo')">
                <el-input
                  v-model="form.vehicle.mainlandRegistrationNo"
                  maxlength="20"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </form-box>
      <!-- 車主資料 -->
      <form-box :title="$t('hzmbH.title.ownerInfo')">
        <div class="form_type1_box">
          <el-row :gutter="86">
            <template v-if="isPerson">
              <el-col :xs="24" :sm="12">
                <el-form-item :label="$t('hzmbH.label.identityType')">
                  <el-select v-model="form.owner.identityType" disabled>
                    <el-option
                      v-for="(item, index) in identityTypeList"
                      :key="index"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item :label="$t('hzmbH.label.identityNo')">
                  <el-input
                    v-model="form.owner.identityNo"
                    maxlength="50"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item :label="$t('hzmbH.label.nameCn')">
                  <el-input
                    v-model="form.owner.nameCn"
                    maxlength="200"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item :label="$t('hzmbH.label.nameEn')">
                  <el-input
                    v-model="form.owner.nameEn"
                    maxlength="200"
                    disabled
                    @input="inputToUpperCase($event, form.owner, 'nameEn')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item :label="$t('hzmbG.label.birthday')">
                  <el-date-picker
                    v-model="form.owner.birthdate"
                    type="date"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </template>
            <template v-if="isCompany">
              <el-col :xs="24" :sm="12">
                <el-form-item :label="$t('hzmbH.label.companyIdentityType')">
                  <el-select v-model="form.owner.companyIdentityType" disabled>
                    <el-option
                      v-for="(item, index) in companyIdentityTypeList"
                      :key="index"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item :label="$t('hzmbH.label.companyBrNo')">
                  <el-input
                    v-model="form.owner.companyBrNo"
                    maxlength="50"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item :label="$t('hzmbH.label.companyBrNameCn')">
                  <el-input
                    v-model="form.owner.companyBrNameCn"
                    maxlength="200"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item :label="$t('hzmbH.label.companyBrNameEn')">
                  <el-input
                    v-model="form.owner.companyBrNameEn"
                    maxlength="200"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </template>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbH.label.macauMobile')"
                prop="owner.macauMobile"
              >
                <el-input
                  v-model="form.owner.macauMobile"
                  maxlength="30"
                  disabled
                >
                  <template slot="prepend">+853</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbH.label.hongKongMobile')"
                prop="owner.hongKongMobile"
              >
                <el-input v-model="form.owner.hongKongMobile" maxlength="100">
                  <template slot="prepend">+852</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item :label="$t('hzmbH.label.otherMobile')">
                <el-input v-model="form.owner.otherMobile" maxlength="100" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbH.label.mainlandPhone')"
                prop="owner.mainlandPhone"
                :rules="[
                  {
                    validator: validateOr,
                    connect: [`owner.mainlandEmail`],
                    trigger: 'change',
                  },
                  {
                    validator: validcodeInlandMobile,
                    trigger: 'change',
                  },
                ]"
              >
                <el-input v-model="form.owner.mainlandPhone" maxlength="100">
                  <template slot="prepend">+86</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item
                :label="$t('hzmbH.label.mainlandEmail')"
                prop="owner.mainlandEmail"
                maxlength="50"
                :rules="[
                  ruleList.email,
                  {
                    validator: validateOr,
                    connect: [`owner.mainlandPhone`],
                    trigger: 'change',
                  },
                ]"
              >
                <el-input v-model="form.owner.mainlandEmail" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <div :class="`tips_red tips_red_${$i18n.locale}`">
                {{ $t("hzmbH.message.mustChooseOne1") }}
              </div>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item
                :label="$t('hzmbH.label.macauAddress')"
                prop="owner.macauAddress"
                :rules="[ruleList.notNull]"
              >
                <el-input
                  v-model="form.owner.macauAddress"
                  ref="ownerMacauAddress"
                  :rows="3"
                  type="textarea"
                  resize="none"
                  maxlength="200"
                  @focus="
                    onAddressClick({
                      ref: 'ownerMacauAddress',
                      title: $t('hzmbH.label.macauAddress'),
                    })
                  "
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="24">
              <el-form-item
                :label="$t('hzmbH.label.hongKongAddress')"
                prop="owner.hongKongAddress"
                :rules="[ruleList.notNull]"
              >
                <el-input
                  v-model="form.owner.hongKongAddress"
                  :rows="3"
                  type="textarea"
                  maxlength="200"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col> -->
          </el-row>
        </div>
      </form-box>
      <!-- 駕駛員信息 -->
      <form-box
        v-if="!['H02'].includes(vehicleSubType)"
        :title="$t('hzmbG.title.drivers')"
      >
        <div v-for="(item, index) in form.drivers" :key="index">
          <FormCard
            :title="
              $t('hzmbG.title.driversIndex', [
                $t(`message.capitalLetter[${index + 1}]`),
              ])
            "
            :showClose="form.drivers.length > 1"
            @close="onRemoveDriver(index)"
          >
            <div class="form_box">
              <el-row :gutter="86">
                <el-col :xs="24" :sm="12">
                  <el-form-item :label="$t('hzmbH.label.nameCn')">
                    <el-input
                      v-model="form.drivers[index].nameCn"
                      maxlength="200"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbH.label.nameEn')"
                    :prop="`drivers.${index}.nameEn`"
                    :rules="[
                      ruleList.notNull,
                      {
                        pattern: /^[A-Za-z !@#$%^&*()_+=[\]{};:',.<>/\|-]*$/,
                        message: $t('hzmbG.message.nameEnChcek'),
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].nameEn"
                      maxlength="200"
                      @input="
                        inputToUpperCase($event, form.drivers[index], 'nameEn')
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbH.label.identityNo')"
                    :prop="`drivers.${index}.identityNo`"
                    :rules="[
                      ruleList.notNull,
                      {
                        validator: identityNoCheck,
                        trigger: 'change',
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].identityNo"
                      maxlength="20"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.birthday')"
                    :prop="`drivers.${index}.birthdate`"
                    :rules="[
                      ruleList.notNull,
                      {
                        validator: olderThan18,
                        trigger: 'change',
                      },
                    ]"
                  >
                    <el-date-picker
                      v-model="form.drivers[index].birthdate"
                      type="date"
                      format="dd/MM/yyyy"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.sex')"
                    :prop="`drivers.${index}.sex`"
                    :rules="[ruleList.notNull]"
                  >
                    <el-select v-model="form.drivers[index].sex">
                      <el-option
                        v-for="(item, index) in sexList"
                        :key="index"
                        :value="item.codeKey"
                        :label="$l(item)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbG.label.nationality')"
                    :prop="`drivers.${index}.nationality`"
                    :rules="[ruleList.notNull]"
                  >
                    <el-select v-model="form.drivers[index].nationality">
                      <el-option
                        v-for="(item, index) in nationalityList"
                        :key="index"
                        :value="item.codeKey"
                        :label="$l(item)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbH.label.macaoDrivingLicenseType')"
                    :prop="`drivers.${index}.macauDrivingLicenseType`"
                    :rules="[ruleList.notNull]"
                  >
                    <el-select
                      v-model="form.drivers[index].macauDrivingLicenseType"
                    >
                      <el-option
                        v-for="(item, index) in drivingLicenseTypeList"
                        :key="index"
                        :value="item.codeKey"
                        :label="$l(item)"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbH.label.macaoDrivingLicenseNo')"
                    :prop="`drivers.${index}.macauDrivingLicenseNo`"
                    :rules="[
                      ruleList.notNull,
                      {
                        pattern: /^[A-Za-z0-9]+$/,
                        message: $t('hzmbG.message.identityNoCheck'),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].macauDrivingLicenseNo"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbH.label.macauMobile')"
                    :prop="`drivers.${index}.macauMobile`"
                    :rules="[
                      ruleList.notNull,
                      {
                        validator: validcodeMacauMobile,
                        trigger: 'change',
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].macauMobile"
                      maxlength="20"
                    >
                      <template slot="prepend">+853</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24">
                  <el-form-item
                    :label="$t('hzmbH.label.macauAddress')"
                    :prop="`drivers.${index}.macauAddress`"
                    :rules="[ruleList.notNull]"
                  >
                    <el-input
                      v-model="form.drivers[index].macauAddress"
                      ref="driversMacauAddress"
                      :rows="3"
                      type="textarea"
                      resize="none"
                      maxlength="200"
                      @focus="
                        onAddressClick({
                          ref: 'driversMacauAddress',
                          title: $t('hzmbH.label.macauAddress'),
                          obj: {
                            index,
                          },
                        })
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbH.label.mainlandPhone')"
                    :prop="`drivers.${index}.mainlandMobile`"
                    :rules="[
                      {
                        validator: validateOr,
                        connect: [`drivers.${index}.mainlandEmail`],
                        trigger: 'change',
                      },
                      {
                        validator: validcodeInlandMobile,
                        trigger: 'change',
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].mainlandMobile"
                      maxlength="30"
                    >
                      <template slot="prepend">+86</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbH.label.mainlandEmail')"
                    :prop="`drivers.${index}.mainlandEmail`"
                    :rules="[
                      ruleList.email,
                      {
                        validator: validateOr,
                        connect: [`drivers.${index}.mainlandMobile`],
                        trigger: 'change',
                      },
                    ]"
                  >
                    <el-input
                      v-model="form.drivers[index].mainlandEmail"
                      maxlength="50"
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24">
                  <div :class="`tips_red tips_red_${$i18n.locale}`">
                    {{ $t("hzmbH.message.mustChooseOne1") }}
                  </div>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbH.label.mainlandDrivingLicenseNo')"
                    :prop="`drivers.${index}.mainlandDrivingLicenseNo`"
                  >
                    <el-input
                      v-model="form.drivers[index].mainlandDrivingLicenseNo"
                      maxlength="20"
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="$t('hzmbH.label.mainlandDrivingPermitNo')"
                    :prop="`drivers.${index}.mainlandDrivingPermitNo`"
                  >
                    <el-input
                      v-model="form.drivers[index].mainlandDrivingPermitNo"
                      maxlength="20"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </FormCard>
        </div>
        <!-- 新增駕駛員按鈕 -->
        <div class="add_driver">
          <GradientBtn
            :disabled="form.drivers.length === 3"
            @click="onAddDrivers"
            >{{
              $t("message.DataRegistration.formData.add_drivers")
            }}</GradientBtn
          >
        </div>
      </form-box>
      <!-- 駕駛員信息 end -->
    </el-form>
    <!-- 下一步 -->
    <div class="next_btn">
      <p class="m-tempsave-tips">{{ $t("message.tempSave_tips") }}</p>
      <GradientBtn @click="onSubmitClick" :loading="submitLoading">
        {{ $t("message.DataRegistration.formData.next") }}
      </GradientBtn>
    </div>
    <!--  -->
    <MacauAddressDialog
      :title="addressDialog.title"
      :visible="addressDialog.show"
      @save="saveMacauAddress"
      @close="addressDialog.show = false"
    ></MacauAddressDialog>
    <!-- end -->
  </div>
</template>

<script>
import {
  getDetail,
  saveFrist,
  saveFollowing,
} from "@/api/hzmb-gh/HzmbHApplicationApi";
import VssViewAPI from "@/api/hzmb-gh/VssViewAPI";
import GradientBtn from "@/components/GradientBtn.vue";
import FormBox from "../components/FormBox.vue";
import FormCard from "../components/FormCard.vue";
import MacauAddressDialog from "../components/MacauAddressDialog.vue";

export default {
  components: { FormBox, GradientBtn, FormCard, MacauAddressDialog },
  data() {
    return {
      serviceType: null,
      loading: false,
      submitLoading: false,
      addressDialog: {
        show: false,
        title: "",
      },
      form: {
        vehicle: {},
        owner: {},
        drivers: [{}],
      },
      status: "",
      identityTypeList: [],
      companyIdentityTypeList: [],
      sexList: [],
      nationalityList: [],
      drivingLicenseTypeList: [],
      ruleList: {
        notNull: {
          required: true,
          message: this.$t("message.formRuleMessage.notNull"),
        },
        email: {
          type: "email",
          message: this.$t("message.formRuleMessage.email"),
          trigger: ["change"],
        },
      },
      vehicleSubType: null,
    };
  },
  computed: {
    isDev() {
      return ["development"].includes(process.env.VUE_APP_ENV);
    },
    isPerson() {
      return ["HZMB_H_FIRST_PERSON"].includes(this.serviceType);
    },
    isCompany() {
      return ["HZMB_H_FIRST_COMP"].includes(this.serviceType);
    },
    isFollowing() {
      return this.status === "FOLLOWING";
    },
  },
  created() {
    this.getSomething();
  },
  methods: {
    //
    async getSomething() {
      this.loading = true;

      try {
        let { f = "" } = this.$route.query;
        this._verifyForm =
          JSON.parse(localStorage.getItem(`verifyFormH${f}`)) || {};
        let {
          serviceType,
          registrationNo,
          identificationNo,
          identityType,
          identityNo,
          nameCn,
          nameEn,
          birthdate,
          mobile,
          email,
          commercialType,
          commercialCode,
          vehicleType,
          vehicleSubType,
        } = this._verifyForm;
        this.vehicleSubType = vehicleSubType;
        this.serviceType = serviceType;

        let { id, vehicle, owner, drivers, status } = await getDetail({
          serviceType,
          registrationNo,
          identificationNo,
          vehicleType,
        });
        this.status = status;

        if (id) {
          this.$set(this, "form", {
            ...this.form,
            id,
            vehicle,
            owner,
            drivers,
          });
        } else {
          this.form.vehicle.registrationNo = registrationNo;
          this.form.vehicle.identificationNo = identificationNo;
          this.form.owner.macauMobile = mobile;
          this.form.owner.macauEmail = email;
          this.$set(this.form.vehicle, "vehicleType", vehicleType);
        }

        if (this.isPerson) {
          this.$set(this.form, "owner", {
            ...this.form.owner,
            identityType,
            identityNo,
            nameCn,
            nameEn: this.inputToUpperCase(nameEn),
            birthdate,
          });

          let identityTypeList = await VssViewAPI.getIdentityTypes();
          this.identityTypeList = identityTypeList.map((item) => {
            return {
              ...item,
              value: item.codeKey,
              label: item[this.$t("message.codeName")],
            };
          });
        } else if (this.isCompany) {
          this.$set(this.form, "owner", {
            ...this.form.owner,
            companyIdentityType: commercialType,
            companyBrNo: commercialCode && commercialCode.substring("2"),
            companyBrNameCn: nameCn,
            companyBrNameEn: this.inputToUpperCase(nameEn),
          });

          this.companyIdentityTypeList =
            await VssViewAPI.getCompanyIdentityTypes();
        }
        this.sexList = await VssViewAPI.getsexs();
        this.nationalityList = await VssViewAPI.getNationalitys();
        let drivingLicenseTypeList = await VssViewAPI.getDrivingLicenseTypes();
        this.drivingLicenseTypeList = drivingLicenseTypeList.filter((item) => {
          return ![7, "7"].includes(item.codeKey);
        });
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
    // 設置日期禁用
    setDateOff(event, value) {
      let { mainlandInsuranceStartDate, mainlandInsuranceEndDate } =
        this.form.vehicle;
      let readyDate = new Date(event).getTime();

      if (value === "mainlandInsuranceStartDate" && mainlandInsuranceEndDate) {
        let endDate = new Date(mainlandInsuranceEndDate).getTime();

        return !(readyDate <= endDate);
      } else if (
        value === "mainlandInsuranceEndDate" &&
        mainlandInsuranceStartDate
      ) {
        let startDate = new Date(mainlandInsuranceStartDate).getTime();

        return !(readyDate >= startDate);
      }

      return false;
    },
    //
    getObjProperty(object, prop) {
      prop = prop || "";
      const paths = prop.split(".");
      let current = object;
      let result = null;
      for (let i = 0, j = paths.length; i < j; i++) {
        const path = paths[i];
        if (!current) break;

        if (i === j - 1) {
          result = current[path];
          break;
        }
        current = current[path];
      }
      return result;
    },
    // 驗證-選擇性必填
    validateOr(rule, value, callback) {
      if (this._forceError) {
        this._forceError = null;
        callback(new Error(this.$t("hzmbH.message.mustChooseOne2")));
        return;
      } else if (this._forceStop) {
        this._forceStop = null;
        return;
      }
      let { connect } = rule;
      let connectValue = this.getObjProperty(this.form, connect[0]);
      if (!value && !connectValue) {
        this._errorValidate = true;
        callback(new Error(this.$t("hzmbH.message.mustChooseOne2")));
        this._forceError = true;
        this.$refs["form"].validateField(connect[0]);
      } else if (value && !connectValue) {
        this._forceStop = true;
        callback();
        this.$refs["form"].validateField(connect[0]);
      } else {
        callback();
      }
    },
    // 驗證-年齡是否達18周歲
    olderThan18(rule, value, callback) {
      let strBirthdayArr = value.split("-");
      let now = new Date();

      let error = false;
      let yearDiff = now.getFullYear() - strBirthdayArr[0] * 1; // 年差
      if (yearDiff < 18) error = true;
      else if (yearDiff === 18) {
        let monthDiff = now.getMonth() + 1 - strBirthdayArr[1] * 1; // 月差
        if (monthDiff < 0) error = true;
        else if (monthDiff === 0) {
          let dayDiff = now.getDate() - strBirthdayArr[2] * 1; // 日差
          if (dayDiff < 0) error = true;
        }
      }

      if (error)
        callback(new Error(this.$t("message.formRuleMessage.olderThan18")));
      else callback();
    },
    // 驗證-內地手機
    validcodeInlandMobile(rule, value, callback) {
      let reg = /^1[3-9][0-9]{9}$/;
      if (value && !reg.test(value)) {
        callback(new Error(this.$t("message.formRuleMessage.macauMobile")));
      } else {
        callback();
      }
    },
    // 驗證-澳門手機
    validcodeMacauMobile(rule, value, callback) {
      let reg = /[6]{1}[0-9]{7}/;
      if (value && !reg.test(value)) {
        callback(new Error(this.$t("message.formRuleMessage.macauMobile")));
      } else {
        callback();
      }
    },
    // 驗證-澳門居民身份證編號
    identityNoCheck(rule, value, callback) {
      let reg = /[0-9]{8}/;
      if (value && !reg.test(value)) {
        callback(new Error(this.$t("message.formRuleMessage.identityNo")));
      } else {
        callback();
      }
    },
    // 輸入字母轉大寫
    inputToUpperCase(val, data, name) {
      if (data) data[name] = val.toUpperCase();
      else return val.toUpperCase();
    },
    //
    onAddDrivers() {
      this.form.drivers.push({});
    },
    //
    async onRemoveDriver(index) {
      try {
        await this.$confirm(
          this.$t("hzmbH.message.deleteConfirm"),
          this.$t("message.tips"),
          {
            confirmButtonText: this.$t("message.confirm"),
            cancelButtonText: this.$t("message.cancel"),
            type: "warning",
          }
        );

        this.form.drivers.splice(index, 1);

        this.$message({
          type: "success",
          message: this.$t("hzmbH.message.deleteSuccess"),
        });
      } catch (error) {
        if (error === false) return;
        else if (error === "cancel") return;
        else this.$error(error);
      }
    },
    //
    onAddressClick({ ref, title, obj }) {
      this.addressDialog.title = title;
      this._addressTemp = {
        ref,
        ...obj,
      };
      this.$nextTick(() => {
        this.addressDialog.show = true;
        let ele = this.$refs[`${ref}`];
        if (!ele.length) ele = [ele];
        for (const i in ele) ele[i].blur();
      });
    },
    //
    saveMacauAddress(evnet) {
      this.addressDialog.show = false;
      this.$nextTick(() => {
        this.addressDialog.title = "";
      });

      let tempString = evnet.textCn.trim();
      if (this._addressTemp.ref === "ownerMacauAddress") {
        this.$set(this.form.owner, "macauAddress", tempString);
      } else if (this._addressTemp.ref === "driversMacauAddress") {
        this.$set(
          this.form.drivers[this._addressTemp.index],
          "macauAddress",
          tempString
        );
      }
    },
    //
    async onSubmitClick() {
      this.submitLoading = true;
      try {
        await this.$refs["form"].validate();

        if (this.isFollowing) {
          let { id = "", vehicle = {} } = this.form;
          let {
            mainlandInsuranceNo,
            mainlandInsuranceStartDate,
            mainlandInsuranceEndDate,
          } = vehicle;
          await saveFollowing({
            applicationId: id,
            mainlandInsuranceNo,
            mainlandInsuranceStartDate,
            mainlandInsuranceEndDate,
          });
        } else
          await saveFrist({
            serviceType: this.serviceType,
            ...this.form,
          });
        this.$router.push({
          name: "hzmbHFirstUpload",
          query: { ...this.$route.query },
        });
      } catch (error) {
        if (error === false)
          this.$message({
            type: "error",
            message: this.$t("message.form_error"),
          });
        else this.$error(error);
      } finally {
        this.submitLoading = false;
      }
    },
    //
    $l(obj, key = "code", tempList) {
      let _setList = ["Cname", "Pname"];
      if (tempList) _setList = tempList;

      const locale =
        _setList[["ZH_TW", "PT"].indexOf(this.$i18n.locale)] || "Tc";
      return obj[`${key}${locale}`] ?? "--";
    },
    // 一鍵賦值測試數據
    setTestValue() {
      let hour = new Date().getHours();
      let min = new Date().getMinutes();
      let add = `-${hour}${min}`;
      //
      this.$set(this.form, "vehicle", {
        ...this.form.vehicle,
        mainlandInsuranceNo: "a1" + add,
        mainlandInsuranceStartDate: "2001-01-01",
        mainlandInsuranceEndDate: "2002-01-01",
        mainlandRegistrationNo: "a2" + add,
      });
      //
      this.$set(this.form, "owner", {
        ...this.form.owner,
        macauMobile: "61234567",
        hongKongMobile: "61234567",
        otherMobile: "a11" + add,
        mainlandPhone: "15886700563",
        mainlandEmail: "a@a.com",
        macauAddress: "a3" + add,
        hongKongAddress: "a4" + add,
      });
      //
      this.$set(this.form.drivers, 0, {
        ...this.form.drivers[0],
        nameCn: "a5" + add,
        nameEn: this.inputToUpperCase("a6" + add),
        identityNo: "13245678",
        birthdate: "2003-01-01",
        sex: "M",
        nationality: "CN",
        macauDrivingLicenseType: "A",
        macauDrivingLicenseNo: "a8" + add,
        macauMobile: "61324567",
        macauAddress: "a12" + add,
        mainlandMobile: "a15" + add,
        mainlandEmail: "a@a.com",
        mainlandDrivingLicenseNo: "a13" + add,
        mainlandDrivingPermitNo: "a14" + add,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.m-mobile_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  .el-select {
    width: 200px;
    margin-right: 16px;
  }
}
.el-input-number__decrease,
.el-input-number__increase {
  height: 46px;
}
.el-input-number {
  line-height: 46px;
}
.m-form__items {
  .el-textarea {
    margin-bottom: 8px;
  }
}
.el-row {
  align-items: flex-start;
}
/deep/.el-form--label-top .el-form-item__label {
  padding: 0;
}
.vehicle-size-row {
  .el-input {
    margin-bottom: 22px;
  }
}
.add_driver {
  margin-top: 24px;
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
/deep/input::-webkit-outer-spin-button,
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
// /deep/input[type="number"] {
//   -moz-appearance: textfield;
// }
.el-form /deep/.el-textarea__inner[rows] {
  height: auto;
}
</style>
